<template>
  <div class="page" style="background-color: #ffffff;width: 100%;height: 100%;">
      <van-nav-bar
        title="员工入职"
        left-text="返回"
        left-arrow
        @click-left="historyBack"
      />
    <el-form ref="form" :model="staffInfo" label-width="80px" :rules="rules" style="padding: 20px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="员工姓名" prop="staffname">
            <el-input v-model="staffInfo.staffname"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="职位" prop="posid">
            <el-select v-model="staffInfo.posid" style="width: 100%">
              <el-option :label="item.constantname" :value="item.constantid" :key="key" v-for="(item,key) in posData"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="staffInfo.phone" type="number"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="性别">
            <el-radio-group v-model="staffInfo.sex" prop="sex">
              <el-radio :label="1" >男</el-radio>
              <el-radio :label="2" >女</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
        <el-row>
            <el-col :span="24">
                <el-form-item label="入职日期">
                    <el-date-picker v-model="staffInfo.changedate" type="date" placeholder="选择日期" class="data-picker" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
            </el-col>
        </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="是否买单">
            <el-radio-group v-model="staffInfo.hasbill" prop="sex">
              <el-radio :label="1" >是</el-radio>
              <el-radio :label="2" >否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="负责门店">
            <el-select v-model="staffInfo.fzstoreid" multiple placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in inteboStores" :key="item.storeid" :label="item.storename" :value="item.storeid"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-button type="primary" @click="saveInteboStaff" style="width: 100%">保存</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
    data() {
        return {
            inteboStores: [],
            opertype: "add",
            posData: [],
            staffInfo: {
                staffname: "",
                posid: "",
                phone: "",
                sex: 2,
                hasbill: 2,
                fzstoreid: [],
                changedate:""
            },
            rules: {
                staffname: [
                    {required: true, message: "请输入员工姓名", trigger: 'blur'},
                ],
                posid: [
                    {required: true, message: "请选择员工职位", trigger: 'blur'},
                ],
                phone: [
                    {required: true, type: "string", len: 11, message: "请输入员工手机号码", trigger: 'blur'},
                ]
            }
        }
    },
    created() {
        this.opertype = this.$route.query.type;
        let updateStaff = this.$route.query.updateStaff;
        if (updateStaff) {
            this.staffInfo = updateStaff;
            this.getInteboStaffManagerStoreid();
        }
        this.getPosData();
        this.getInteboStore();
    },
    methods: {
        getInteboStaffManagerStoreid() {
            this.$post("inteboStaff/getInteboStaffManagerStoreid", {staffid: this.staffInfo.staffid}).then(res => {
                if (res.sucess) {
                    this.staffInfo.fzstoreid = res.object;
                } else {
                    this.$message.error(res.$message);
                }
            });
        },
        getInteboStore() {
            this.$post("inteboStore/getInteboStoreByCoop").then(res => {
                if (res.sucess) {
                    this.inteboStores = res.object;
                } else {
                    this.$message.error(res.$message);
                }
            });
        },
        getPosData() {
            this.$post("basis/getConstantInfo", {
                storeid: "320c07ba76e94b0d8735aefe4470c07a",
                constanttype: "YTBZW",
                lv: 2,
                status: 0,
                guid: ""
            }).then(res => {
                if (res.sucess) {
                    this.posData = res.object;
                }
            });
        },
        saveInteboStaff() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    let url = "inteboStaff/saveInteboStaff";
                    if (this.opertype == "update") {
                        url = "inteboStaff/updateInteboStaff";
                    }
                    this.$postw(url, this.staffInfo).then(res => {
                        if (res.sucess) {
                            this.$message({
                                message: '入职成功',
                                type: 'success',
                                duration: 1000,
                                onClose: () => {
                                    this.$router.push('/staffinfo');
                                }
                            });
                        }
                    });
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/intebo/intebostaff/addstaffinfo.vue